import { Navigate, useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { userAtom, authLoadingAtom } from '../../state/userAtom';
import { Center, Spinner } from '@chakra-ui/react';

function ProtectedRoute({ children }) {
  const user = useRecoilValue(userAtom);
  const authLoading = useRecoilValue(authLoadingAtom);
  const location = useLocation();

  // Show loading spinner while checking auth
  if (authLoading) {
    return (
      <Center minH="100vh">
        <Spinner size="xl" color="brand.500" thickness="4px" />
      </Center>
    );
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

export default ProtectedRoute;
